/**
 * Ethers.js provider, which can be used with an instance of the Ethers.js Provider class.
 */
var provider = {
  isProvider: function isProvider(a) {
    return void 0 !== (null === a || void 0 === a ? void 0 : a.send);
  },
  send: function send(a, b, c) {
    return a.send(b, c);
  }
};
export default provider;